import { takeLatest, put } from 'redux-saga/effects';
import { actions } from '../slices/BusStopPerformanceSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import { call } from 'redux-saga/effects';

function* getBusStopPerformance({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_stop_performance')}`, {
            params: {
                ...filters,
                page: undefined,
                size: undefined,
            },
        });

        yield put({ type: actions.get_bus_stop_performance_succeed.type, payload: { ...response.data, dataWithTable: response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_bus_stop_performance_failed.type, payload: error });
    }
}

function* exportBusStopPerformance({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_stop_performance')}`, {
            params: {
                ...filters,
                export: true,
                page: undefined,
                size: undefined,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        const action = { filters };
        yield call(getBusStopPerformance, { payload: action });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_bus_stop_performance_failed.type, payload: error });
    }
}

function* watchRequestDetail() {
    yield takeLatest(actions.get_bus_stop_performance.type, getBusStopPerformance);
    yield takeLatest(actions.export_bus_stop_performance.type, exportBusStopPerformance);
}

export default watchRequestDetail;
